import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import notification from "./modules/notification";
import project from "./modules/project";
import team from "./modules/team";
import clip from "./modules/clip";
import video from "./modules/video";
import game from "./modules/game";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        notification,
        project,
        team,
        clip,
        video,
        game
    },
    strict: true
});

export default store;
